import Icon from '../components/Icon.vue'

Icon.register({
  broom: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M256.5 216.8l86.7 109.2s-16.6 102.4-76.6 150.1c-60 47.8-266.6 34.1-266.6 34.1s3.8-23.1 11-55.4l94.6-112.2c4-4.7-0.9-11.6-6.7-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 60-47.8 163.3-40.9 163.3-40.9zM636.5 31c5.5 6.9 4.3 17-2.5 22.4l-232.5 177.8 34.1 42.9c5.1 6.4 1.7 15.9-6.3 17.6l-58.8 12.5-86.7-109.2 25.3-54.5c3.5-7.4 13.5-8.6 18.6-2.2l34.1 43 232.5-177.8c6.9-5.5 16.9-4.3 22.4 2.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/broom.js
// module id = 1123
// module chunks = 0